import CollectionDataForm from './collection-update-form';

export default CollectionDataForm;